<template>
<div>
    <div :class="accordionClasses">
        <div @click="toggleAccordion">
            <slot name="header"></slot>
        </div>
        <slot name="body"></slot>
    </div>
</div>
</template>

<script>
export default {
    name: "Accordian",

    components: {

    },

    data() {
        return {
            isOpen: false
        }
    },

    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen;
        }
    },

    computed: {
        accordionClasses() {
            return {
                'is-closed': !this.isOpen,
            };
        }
    },

};
</script>

<style lang="css" scoped>
.list-item {
    display: visible;
    overflow: hidden;
    transition: 0.5s ease all;
}

.is-closed .list-item {
    display: none;
}
</style>
